import {
  BoxProps,
  Button,
  ButtonProps,
  Link,
  ThemingProps,
} from '@chakra-ui/react'

import { useApp } from '../hooks/useApp'
import { FooterCarkulka } from './FooterCarkulka'
import { FooterCestovko } from './FooterCestovko'
import { FooterChaloupka } from './FooterChaloupka'

export interface FooterProps extends BoxProps, ThemingProps {
  hideLinks?: boolean
}

export interface FooterLinkProps extends ButtonProps {
  children: React.ReactNode
  href: string
  target?: HTMLAnchorElement['target']
}

export const FooterLink = ({
  children,
  href,
  target,
  ...rest
}: FooterLinkProps) => {
  return (
    <Button
      as={Link}
      variant="ghost"
      size="xs"
      colorScheme="whiteAlpha"
      href={href}
      target={target || '_blank'}
      rel="noopener noreferrer"
      _hover={{
        bg: 'transparent',
      }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export const Footer = ({ sx, variant, hideLinks = false }: FooterProps) => {
  const { app } = useApp()

  if (app == 'cestovko') return <FooterCestovko />

  if (app == 'chaloupka') return <FooterChaloupka />

  return <FooterCarkulka />
}
